import {
    downloadDocument,
    trimFileExtension
} from "../../../../CommonFunctions";
import {Document, ICustomerPortalService, Types} from "@falcon/services";
import {PluginTemplates} from "@falcon/plugin-falcon-journey";
import {iocContainer} from "@athena-portal/core";

interface DocumentProps {
    document: Document;
}

function DocumentBlock({document}: Readonly<DocumentProps>) {

    const customerPortalService: ICustomerPortalService = iocContainer.get<ICustomerPortalService>(Types.CustomerPortalService);

    function downloadDocumentAction(doc: Document) {
        customerPortalService.downloadDocument(doc.id)
            .subscribe((documentContents: ArrayBuffer) => {
                if (documentContents) {
                    downloadDocument(documentContents, doc.name);
                }
            });
    }

    return (
        <tr key={document.id}>
            <td id="document-date" className="muli-semi-bold-16 pt-3">
                <span className="font-weight-extra-light fs-14 ml-2">
                    {PluginTemplates.convertDate(document.date, "DD MMMM YYYY")}
                </span>
                <div className={"row ml-2"}>
                    <button
                      type="button"
                      className="col-10 pt-3 pl-0 h5-style"
                      onClick={() => downloadDocumentAction(document)}
                    >
                      {document.title}
                    </button>
                    <button
                        className="col-2 pl-1 no-background-and-borders"
                        onClick={() => downloadDocumentAction(document)}
                        id={trimFileExtension(document.name)}
                    >
                        <img
                            className="active-policy-download-icon"
                            alt="Document download icon"
                            src="/img/Flow-download.svg"
                        />
                    </button>
                </div>
            </td>
        </tr>
    );
}

export default DocumentBlock;
